import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_CONFIG } from '../config/api';

const API = API_CONFIG.ENDPOINTS.USERS;
const ROLES = ['admin', 'finance', 'user'];

const UserForm = ({ userId }) => {
  const params = useParams();
  const effectiveUserId = userId ?? params.id ?? null;
  const [form, setForm] = useState({ username: '', first_name: '', last_name: '', email: '', role: 'user', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('token');

  const isEdit = !!effectiveUserId;

  useEffect(() => {
    const fetchUser = async () => {
      if (!isEdit || !effectiveUserId) return;
      try {
        const res = await fetch(`${API}/${effectiveUserId}`, { headers: { Authorization: `Bearer ${token}` } });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Failed to fetch user');
        setForm({ ...data, password: '' });
      } catch (e) {
        setError(e.message);
      }
    };
    fetchUser();
  }, [effectiveUserId, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const method = isEdit ? 'PUT' : 'POST';
      const url = isEdit ? `${API}/${effectiveUserId}` : API;
      const body = { first_name: form.first_name, last_name: form.last_name, email: form.email, role: form.role };
      if (!isEdit) {
        body.username = form.username;
        if (!form.password) return setError('Lozinka je obavezna.');
        body.password = form.password;
      } else {
        // allow username change as admin
        if (form.username) body.username = form.username;
        if (form.password) body.password = form.password;
      }
      
      
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Greška pri spremanju');
      setSuccess('Spremljeno.');
      if (!isEdit) setForm({ username: '', first_name: '', last_name: '', email: '', role: 'user', password: '' });
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm max-w-lg mx-auto">
      <div className="px-4 py-3 border-b border-gray-200">
        <h2 className="text-2xl font-semibold text-gray-900">{isEdit ? 'Uredi korisnika' : 'Novi korisnik'}</h2>
        <p className="text-sm text-gray-600 mt-1">Unesite osnovne podatke i rolu korisnika.</p>
      </div>
      <div className="p-4 md:p-6">
        {error && <div className="mb-3 text-red-700 bg-red-100 p-2 rounded">{error}</div>}
        {success && <div className="mb-3 text-green-700 bg-green-100 p-2 rounded">{success}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Korisničko ime</label>
            <input name="username" value={form.username} onChange={handleChange} className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3" required={!isEdit} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Ime</label>
              <input name="first_name" value={form.first_name} onChange={handleChange} className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Prezime</label>
              <input name="last_name" value={form.last_name} onChange={handleChange} className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3" required />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Rola</label>
            <select name="role" value={form.role} onChange={handleChange} className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3">
              {ROLES.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Lozinka {isEdit ? '(ostavite prazno za nepromijeniti)' : ''}</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3" />
          </div>
          <div className="pt-2 flex justify-end">
            <button type="submit" className="px-5 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">Spremi</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
